import urls from './urls'
import base from './base'

const get = async () => {
  const result = await base.getMethod(urls.EVENTS)
  return result
}


export default {get}